import { modifier } from 'ember-modifier';
import { waitForLater } from 'ember-simplepractice/utils/waiters';

export default modifier(function autoResizeTextarea(element) {
  let isUserResizing = false;

  function resize() {
    if (isUserResizing) return;

    element.style.transition = 'height 0.2s ease-in-out';
    element.style.height = 'auto';

    const scrollHeight = element.scrollHeight;
    const computedStyle = getComputedStyle(element);
    const minHeight = parseInt(computedStyle.minHeight) || 100;
    const lineHeight = parseInt(computedStyle.lineHeight) || 20;
    const minHeightForContent = Math.ceil(scrollHeight / lineHeight) * lineHeight;

    if (minHeightForContent > minHeight) {
      element.style.height = scrollHeight + 'px';
    } else {
      element.style.height = minHeight + 'px';
    }
  }

  async function handleResize() {
    isUserResizing = true;
    element.style.transition = 'none';
    await waitForLater(100);
    isUserResizing = false;
  }

  if (element.value.trim() !== '') {
    resize();
  }

  element.addEventListener('input', resize);
  element.addEventListener('mousedown', handleResize);
  element.addEventListener('touchstart', handleResize);

  return () => {
    element.removeEventListener('input', resize);
    element.removeEventListener('mousedown', handleResize);
    element.removeEventListener('touchstart', handleResize);
  };
});
